// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'

import getShortPitchName from 'bam-node-baseball-savant/utils/get-short-pitch-name.ts'
import { getPitchTypeColor } from 'bam-node-baseball-savant/utils/pitch-type-colors'
import { PitchPillElementProps } from './utils/types.ts'
import {
    prettyPitchArsenalNames,
    mobilePrettyPitchArsenalNames,
} from './utils/stat-groupings.ts'
import useResponsiveDimensions from './utils/responsive-dimensions.tsx'

function PitchPillElement(props: PitchPillElementProps) {
    const { pitchType, statName, flipOrder, x, y, textClass, rightJustify } =
        props

    const BOX_WIDTH = 250
    const { isMobile } = useResponsiveDimensions()

    const mapToUse = isMobile
        ? mobilePrettyPitchArsenalNames
        : prettyPitchArsenalNames

    return (
        <foreignObject
            x={rightJustify ? x - BOX_WIDTH : x}
            y={y - 9}
            width={BOX_WIDTH}
            height={30}
        >
            <div
                className={`${textClass} comp-tool-pitch-pill-container`}
                // eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any
                {...({ xmlns: 'http://www.w3.org/1999/xhtml' } as any)}
                style={{
                    justifyContent: rightJustify ? 'flex-end' : 'flex-start',
                }}
            >
                {flipOrder && mapToUse[statName]}
                <div
                    className="comp-tool-pitch-pill-text"
                    style={{
                        backgroundColor: getPitchTypeColor(pitchType),
                        color: pitchType === 'sl' ? 'black' : 'white',
                        WebkitTextFillColor:
                            pitchType === 'sl' ? 'black' : 'white',
                        marginRight: flipOrder ? '4px' : '0px',
                        marginLeft: !flipOrder ? '4px' : '0px',
                    }}
                >
                    {getShortPitchName(pitchType)}
                </div>
                {!flipOrder && mapToUse[statName]}
            </div>
        </foreignObject>
    )
}

export default PitchPillElement
